import { Component, inject } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { ConditionalBlock } from './conditional-block';
import { ContentBlock, ContentBlocksService, ContentModule } from '@tytapp/content';

@Component({
    selector: 'tyt-conditional-block',
    standalone: true,
    imports: [
        ContentModule
    ],
    template: `
        <tyt-content-view [blocks]="visibleBlocks"></tyt-content-view>
    `
})
export class ViewComponent extends ContentBlockViewComponent<ConditionalBlock> {
    private contentBlocks = inject(ContentBlocksService);

    visibleBlocks: ContentBlock[] = [];

    async onBlockChanged() {
        await this.determineContent();
    }

    async determineContent() {
        for (let branch of this.block?.branches ?? []) {
            if (await this.contentBlocks.evaluateCondition(branch.condition)) {
                this.visibleBlocks = branch.blocks;
                return;
            }
        }

        this.visibleBlocks = [];
    }
}
